import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useUser } from '../context/user.context';

// ======================================================= //

export default function EditTable({table, tableIndex, setTable}) {

    const {user, updateUser} = useUser();

    const [dialogOpen, setDialogOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);

    const [tableName, setTableName] = useState(table.name);

    // ------------------------------------------------------- //

    const handleDelete = () => {

        const new_tables = user.tables.filter((v, i) => {
            if(i === tableIndex) return false;
            return true;
        });

        const new_user = {
            ...user,
            tables: new_tables
        }
        
        if(user.lastID === table.id + 1) new_user.lastID--;
        updateUser(new_user);
    }

    const handleEdit = () => {

        // if the name is already the same, what's the point of it?
        if(tableName.trim() === table.name) {
            setDialogOpen(false);
            return;
        }

        const new_user = {...user}, new_table = {...table, name: tableName};
        new_user.tables[tableIndex] = new_table;

        setTable(new_table);
        updateUser(new_user);

        setDialogOpen(false);
    }

    // ------------------------------------------------------- //

    return (
        <React.Fragment>

            <Typography
                component='div' 
                variant='caption' 
                color='text.secondary' 
                sx={{marginBottom: "5vh", cursor: 'pointer'}}
                onClick={() => setDialogOpen(true)}
            >
                Edit Table
            </Typography>

            <Dialog 
                open={dialogOpen}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogTitle>Editing Table</DialogTitle>
                <DialogContent>

                    <TextField
                        autoFocus
                        defaultValue={tableName}
                        margin="dense"
                        id="name"
                        label="Table Name"
                        type="name"
                        fullWidth
                        variant="standard"
                        onChange={(event) => setTableName(event.target.value)}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleEdit}>Edit</Button>
                    <Button color='error' onClick={() => setDeleteOpen(true)}>Delete</Button>
                    <Button onClick={() => setDialogOpen(false)} color='secondary'>Cancel</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteOpen}>

                <DialogTitle>
                    Delete table?
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                    Please make sure before clicking the delete button. This can't be undone. You will lose all your data.
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button color='error' onClick={handleDelete}>
                        Delete
                    </Button>
                    <Button color='secondary' onClick={() => setDeleteOpen(false)}>Cancel</Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    )
}